import React,{ Component } from 'react';

import { Progress } from 'reactstrap';

import find from 'lodash/find';

import Link from 'react-router-dom/NavLink';
import SortableTable from '../../../shared/components/SortableTable';
import Button from '../../../shared/components/Button';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import DateRange from '../../../shared/components/DateRange';
import DropdownButton from '../../../shared/components/DropdownButton';

import { formatStatus, emojiUrlForRating } from '../../../shared/utils';

class CampaignList extends Component {
  getAverageCampaignRatingById(id){
    const matchingCampaign = find(this.props.campaignKPIs,(kpi) => kpi.campaignId === id);

    return matchingCampaign ? Number(matchingCampaign.averageRating) : null
  }

  getBrandNameById(id){
    const match = find(this.props.brands, (brand) => brand.id === id);
    return match ? match.name : 'Unknown Brand';
  }

  getTotalCampaignCompletionsById(id){
    return this.props.campaignKPIs
      .filter((kpi) => kpi.campaignId === id)
      .reduce((sum,kpi) => sum + kpi.totalCompletions,0);
  }

  getLinkHref(campaign){
    const { status, id } = campaign,
      currentUrl = this.props.currentUrl;

    if(status === 'draft') return `${currentUrl}/create/${id}`;
    if(status === 'pendingAdjoy') return `${currentUrl}/${id}/review`;
    if(status === 'pendingAgency') return `${currentUrl}/${id}/review`;

    return `${currentUrl}/${id}/responses`;
  }

  getBudgetProgressById(id){
    const matchingCampaign = find(this.props.campaignKPIs, (kpi) => kpi.campaignId === id);

    return matchingCampaign ? parseFloat(matchingCampaign.budgetSpent) : null
  }

  getDemoStatusById(id){
    const matchingCampaign = find(this.props.campaignKPIs, (kpi) => kpi.campaignId === id);

    return matchingCampaign ? matchingCampaign.demoStatus : null    
  }

  renderButtonsForCampaign(campaign){
    const status = campaign.status,
      isDemo = !!this.getDemoStatusById(campaign.id);

    if(status === 'active' || status === 'ready' || isDemo){
      return (
        <div className='pull-right'>
          <Button
            className='CampaignResultsButton'
            linkHref={`${this.props.currentUrl}/${campaign.id}/responses`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Duplicate', 
                onClick:() => this.props.onDuplicateClick(campaign.id)
              }
            ]} 
          />
        </div>
      ) 
    } else if(status === 'draft'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.currentUrl}/create/${campaign.id}`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Edit
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Duplicate', 
                onClick:() => this.props.onDuplicateClick(campaign.id)
              },
              {
                text:'Move to trash', 
                confirmationText:'This is permanent and can not be reverted.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => this.props.onDeleteClick(campaign.id)
              }
            ]} 
          />
        </div>
      );
    } else if(status === 'pendingAgency' || status === 'pendingAdjoy'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.currentUrl}/${campaign.id}/review`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Review
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Duplicate', 
                onClick:() => this.props.onDuplicateClick(campaign.id)
              }
            ]} 
          />
        </div>
      );
    } else if(status === 'suspended'){
      return (
        <div className='pull-right'>
          <Button
            className='CampaignResultsButton'
            linkHref={`${this.props.currentUrl}/${campaign.id}/responses`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              // {
              //   text:'Edit', 
              //   onClick:() => this.props.onRevertClick(campaign.id)
              // },
              {
                text:'Duplicate', 
                onClick:() => this.props.onDuplicateClick(campaign.id)
              }
            ]} 
          />
        </div>
      )
    } else {
      return (
        <div className='pull-right'>
          <Button
            className='CampaignResultsButton'
            linkHref={`${this.props.currentUrl}/${campaign.id}/responses`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton 
            options={[
              {
                text:'Duplicate', 
                onClick:() => this.props.onDuplicateClick(campaign.id)
              }
            ]} 
          />
        </div>
      );
    }
  }

  render(){
    return (
      <div className='DashboardCampaignList'>
        <SortableTable
          columns={[
            {name:'status', width:12, sortable:true},
            {name:'experience', width:25, sortable:true},
            {name:'completions', width:15, sortable:true},
            {name:'rating', width:13, sortable:true},
            {name:'budget', width:15, sortable:true},
            {name:'', width:20}
          ]}
          onSort={(sortColumn,sortDescending) => this.props.onSort(sortColumn,sortDescending)}
          hideHeadersOnEmpty
          emptyText={this.props.emptyText}
        >
          {this.props.campaigns.map((campaign) => {
            const rating = this.getAverageCampaignRatingById(campaign.id) || 0,
              completions = this.getTotalCampaignCompletionsById(campaign.id) || 0,
              emojiUrl = emojiUrlForRating(rating),
              budgetProgress = this.getBudgetProgressById(campaign.id) || 0,
              isOrHasBeenLive = ['active','complete','suspended','outOfFunds'].indexOf(campaign.status) >= 0,
              demoStatus = this.getDemoStatusById(campaign.id),
              isDemo = !!demoStatus;

            return (
              <tr key={campaign.id}>
                <td>
                  <div className="list-status">
                    {formatStatus(isDemo ? demoStatus : campaign.status)}
                  </div>
                </td>
                <td>
                  <div className="list-title">
                    <Link to={this.getLinkHref(campaign)}>
                      {campaign.name || 'Untitled Campaign'}
                    </Link>
                  </div>
                  <div className="list-subtitle">
                    {this.getBrandNameById(campaign.companyId)}
                  </div>
                  <DateRange 
                    launchDate={campaign.launchDate} 
                    endDate={campaign.endDate} 
                  />
                </td>
                <td>
                  {(isOrHasBeenLive || isDemo) && completions.toLocaleString()}
                </td>
                <td>
                  {((isOrHasBeenLive || isDemo) && completions > 0) && (
                    <span>
                      <img
                        src={emojiUrl}
                        className='EmojiRating'
                        alt='rating'
                      />
                      &nbsp;&nbsp;
                      <span>{(rating + 1).toFixed(2)}</span>
                    </span>
                  )}

                  {((isOrHasBeenLive || isDemo) && completions === 0) && (
                    <span>N/A</span>
                  )}
                </td>
                <td className='DontBreakWordOnWrap'>
                  <MoneyDisplay>{campaign.lifetimeBudget}</MoneyDisplay>
                  {(isOrHasBeenLive || isDemo) && (
                    <div>
                      <Progress
                        className='BudgetProgressBar'
                        value={(budgetProgress / campaign.lifetimeBudget) * 100}
                      />
                      <small>
                        <MoneyDisplay>{Math.abs(campaign.lifetimeBudget - budgetProgress)}</MoneyDisplay>
                        &nbsp;{(campaign.lifetimeBudget - budgetProgress) > 0 ? 'remaining' : 'over budget'}
                      </small>
                    </div>
                  )}
                </td>
                <td>
                  {this.renderButtonsForCampaign(campaign)}
                </td>
              </tr>
            )
          })}
        </SortableTable>
      </div>
    )
  }
}

CampaignList.defaultProps = {
  userIsOwner:false,
  campaignKPIs:[],
  campaigns:[],
  brands:[],
  currentUrl:'',
  onDeleteClick:() => {},
  onSuspendClick:() => {},
  onResumeClick:() => {},
  emptyText:''
};

export default CampaignList;



// WEBPACK FOOTER //
// ./src/routes/AgencyCampaignsDashboard/components/CampaignList.js